/**
 * 俄语（ru-RU）
 */
export default {
  orderList: {
    AllOrder: 'весь порядок',
    WaitingPayment: 'ждать уплаты',
    Pending: 'ожидание отгрузки',
    ToBeSighed: 'в пути',
    Refunding: 'возврат денежных средств',
    YouHave: 'У тебя есть',
    orders: 'команда',
    OrderID: 'номер заказа',
    Customer: 'покупатель',
    coupon: 'купон',
    TotalAmount: 'Общая сумма',
    PayNow: 'платить сейчас',
    ViewDetails: 'сведения',
    CancelOrder: 'аннулировать заказ',
    Delete: 'Удалить',
    selectContent: 'выбор содержимого',
    startDate: 'Дата начала',
    endDate: 'Дата окончания',
    inputPlaceholder: 'поиск по имени заказа',
    RequestRefund: 'требовать возврата',
    ConfirmReceipt: 'подтверждать получение',
    CancelReason: 'аннулировать',
    Verification: 'проверка',
    RefundReason: 'причина возврата',
    Remake: 'Замечания',
    cancel: 'отмена',
    submit: 'Решения',
    ConfirmReceiptTitle: 'Вы уверены, что получили товар и качество соответствует соглашению сторон?',
    ConfirmReceiptContent: 'Если подтверждение правильности, нажмите на кнопку "подтвердить" для завершения подтверждения получения.',
    removeTheStore: 'Удалить из памяти',
    CancellationReasonIsRequired: 'причина отмены необходима',
    RefundReasonIsRequired: 'причина возврата денег обязательна',
    Paypal: 'Paypal',
    CreditCard: 'кредитная карточка',
    Balance: 'равновесие',
    SelectByStatus: 'выбор по состояниям',
    SelectByPlatform: 'выбор по платформе',
    FulfillOrder: 'выполнить заказ',
    Store: 'магазин',
    StoreOrderID: 'идентификатор заказа магазина',
    TrackingNumber: 'номер запроса',
    ShippingCarrier: 'перевозчик',
    TrackingURL: 'веб - сайт',
    cancelBtn: 'отмена',
    ok: 'OK',
    emptyTips1: 'ваш заказ пуст!',
    emptyTips2: 'Здесь вы можете управлять и обрабатывать заказы',
    ChooseProduct: 'выбор продукции',
    ChooseProductTips: 'как найти и показать Prodcuts',
    ConnectANewStore: 'подключиться к новому магазину',
    ConnectANewStoreTips: 'как подключиться к новому магазину',
    selectAll: 'полное обогащение',
    orderStatusSubTip: 'Не удалось вернуть деньги, пожалуйста, свяжитесь с нашей группой поддержки'
  },
  orderDetail: {
    PayNow: 'платить сейчас',
    ConfirmReceipt: 'подтверждать получение',
    StoreOrderID: 'идентификатор заказа магазина',
    OrderID: 'номер заказа',
    Source: 'источник',
    IncomeStatement: 'отчет о прибылях и убытках',
    CommodityInformation: 'товарная информация',
    ShipFrom: 'следовать',
    ItemNo: 'нумерация пунктов',
    TheDetail: 'подробности',
    Notes: 'заметки',
    OrderStatus: 'состояние заказа',
    BalancePayment: 'платежный баланс',
    PaymentTime: 'срок платежа',
    PaymentId: 'Идентификатор платежа',
    ItemSubtotal: 'итог',
    ShippingSubtotal: 'доставлять товары',
    tax: 'налог',
    PaymentAmount: 'сумма платежа',
    ShippingAddress: 'адрес доставки',
    ConfirmReceiptModalTitle: 'Вы уверены, что получили товар и качество соответствует соглашению сторон?',
    ConfirmReceiptModalContent: 'Если подтверждение правильности, нажмите на кнопку "подтвердить" для завершения подтверждения получения.',
    Cancel: 'отмена',
    Submit: 'Представлять на рассмотрение',
    removeTheStore: 'Удалить из памяти',
    WaitingPayment: 'ждать уплаты',
    WaitingPaymentTips: 'Ваше заказанное блюдо ещё не оплачено. Нажмите кнопку немедленно для продолжения. ',
    OrderCreation: 'Создание заказа',
    Finish: 'выполнить',
    PaymentSuccessful: 'платить успешно',
    IncorrectAddressInformation: 'Неверная адресная информация',
    CancelTips: 'ваш заказ отменен',
    Pending: 'ожидание отгрузки',
    PendingSecondStatus: 'обычно не более 24 часов.',
    PendingTips: 'каждый продукт перед отправкой к вашему клиенту проходит наш строгий контроль качества.',
    Shipped: 'погрузка',
    Complete: 'полный',
    ShippedTips1: 'ваш заказ скоро будет готов!',
    PartialDelivery: 'частичная погрузка',
    ShippedTips2: 'некоторые ваши продукты еще не отправлены',
    Refunding: 'возврат денежных средств',
    PartialRefund: 'Частичное возмещение',
    refundedTipsNew: 'Общая сумма возврата по вашему заказу составляет',
    RefundingSecondStatus: 'возврат денежных средств будет произведен в течение 1 - 3 рабочих дней',
    RefundingTips: 'Refund request has been submitted. Waiting to be processed',
    Refund: 'возврат денежных средств',
    Refunded: 'возвращать',
    RefundedSecondStatus: 'По данным вашего финансового учреждения, деньги на вашем счете могут занять до 14 дней',
    RefundedTips: 'Просьба о возврате была удовлетворена. выплаченная сумма будет возвращена в соответствии с первоначальной формой платежа',
    CompleteSecondStatus: 'завершение операции',
    CompleteTips: 'заказ выполнен, спасибо за поддержку',
    ShippingMethod: 'вид транспорта',
    MyOrder: 'Я заказывал',
    OrderInformation: 'Информация о заказе',
    Product: 'продукт',
    PurchasePrices: 'цена покупки',
    prices: 'цена',
    Quantity: 'количество',
    Subtotal: 'итог',
    Profit: 'прибыль',
    ConfirmReceiptTips: 'расписка',
    trackingCode: 'код сопровождения',
    DeliveryTime: 'срок поставки',
    logisticsProviders: 'поставщик логистики',
    payment: 'платить',
    NotToDeliverGoods: 'не доставлять',
    LogisticsInformation: 'логистическая информация',
    PartialDeliveryTips: 'Некоторые продукты еще не отправлены. Мы сообщим вам, как только они будут отправлены.',
    PaymentInformation: 'Информация о платеже',
    Balance: 'равновесие',
    CreditCard: 'кредитная карта',
    payFail: 'ошибка платежа',
    Remaining: 'остаток',
    WaitingPaymentWarning: 'Неоплаченные заказы сверх 120 часов будут аннулированы',
    OrderCancelled: 'отмена заказа',
    OrderConfirmed: 'подтверждение заказа',
    Shipping: 'судоходство',
    OrderComplete: 'доставка',
    OrderSubmitted: 'представлять заказ',
    PleaseInput: 'Пожалуйста, введите',
    Note: 'Примечание',
    EditNote: 'Редактировать заметку',
    Edit: 'Редактировать',
    EditNoteSuccessTip: 'Содержимое заметки успешно обновлено.',
    NoteTip: 'Вот содержание заметки.'
  }
}
